import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'innovation-tracker',
    description:
      'Track the progress of Attain Innovation in generating ideas, implementing solutions, and piloting deliverables to generate assets',
    icon: 'thunder',
    name: 'Innovation Tracker',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
